export const TYPES = {
  HttpService: Symbol.for('Http/HttpService')
};
